export const DEMO_TODAY = '2026-10-16';

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  maximumFractionDigits: 0,
});

const preciseCurrencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const unitFormatter = new Intl.NumberFormat('en-AU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
});

export function money(value: number, precise = false): string {
  return (precise ? preciseCurrencyFormatter : currencyFormatter).format(value);
}

export function compactMoney(value: number): string {
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(abs >= 10_000_000 ? 1 : 2)}m`;
  if (abs >= 1_000) return `${sign}$${Math.round(abs / 1_000)}k`;
  return money(value);
}

export function units(value: number): string {
  return unitFormatter.format(value);
}

export function pct(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}

export function unitPrice(value: number): string {
  return `$${value.toFixed(4)}`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function date(iso?: string): string {
  if (!iso) return '—';
  const [year, month, day] = iso.slice(0, 10).split('-');
  return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}`;
}

export function dateTime(iso?: string): string {
  if (!iso) return '—';
  const time = iso.length > 10 ? iso.slice(11, 16) : '';
  return time ? `${date(iso)}, ${time}` : date(iso);
}

export function addDays(iso: string, days: number): string {
  const value = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  value.setUTCDate(value.getUTCDate() + days);
  return value.toISOString().slice(0, 10);
}

export function addMonths(iso: string, months: number): string {
  const value = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  value.setUTCMonth(value.getUTCMonth() + months);
  return value.toISOString().slice(0, 10);
}

export function daysBetween(fromIso: string, toIso: string): number {
  const from = Date.parse(`${fromIso.slice(0, 10)}T00:00:00Z`);
  const to = Date.parse(`${toIso.slice(0, 10)}T00:00:00Z`);
  return Math.round((to - from) / 86_400_000);
}

export function nowStamp(): string {
  const now = new Date();
  const clock = [now.getHours(), now.getMinutes(), now.getSeconds()]
    .map((part) => String(part).padStart(2, '0'))
    .join(':');
  return `${DEMO_TODAY}T${clock}`;
}

export function financialYear(iso: string): string {
  const year = Number(iso.slice(0, 4));
  const month = Number(iso.slice(5, 7));
  const end = month >= 7 ? year + 1 : year;
  return `FY${end}`;
}

export function humanise(value: string): string {
  const lower = value.replace(/_/g, ' ').toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function round2(value: number): number {
  return Math.round(value * 100) / 100;
}

export function maskAccount(accountNumber: string): string {
  return `•••• ${accountNumber.slice(-3)}`;
}
